const indispensable = [
    {label: "Reemplazar equipos o maquinaria que cumplió su vida útil", value: 'REPLACEMENT'},
    {label: "Integrar un proceso que actualmente se terceriza a través de un equipo alquilado o un tercero", value: "INTEGRATE_THIRD_PARTY_SERVICE"},
    {label: "Nueva línea de negocio o servicio relacionada a su actividad actual", value: "NEW_DEAL_LINE"},
    {label: "Aumento de capacidad instalada", value: "CAPACITY_INCREASE"},
    {label: "Nueva actividad comercial diferente a la que desarrolla actualmente", value: "NEW_ACTIVITY"}
]

export default indispensable;